<mat-form-field appearance="outline" class="ca-form-field ca-form-field-s" style.width="{{ width() }}">
    <ca-icon matPrefix icon="magnifier" aria-label="Filter" class="ca-icon-s-19-p-0-f-19"></ca-icon>

    <input
        matInput
        type="text"
        placeholder="{{ placeholder() }}"
        aria-placeholder="{{ placeholder() }}"
        (input)="search($event.target.value)"
        [value]="value()"
    />

    @if (value() !== '') {
        <ca-icon
            (click)="clearSearch()"
            matSuffix
            icon="cross-circle"
            aria-label="Clear"
            class="ca-icon-s-19-p-0-f-19 cursor-pointer"
        ></ca-icon>
    }
</mat-form-field>
